import { render, staticRenderFns } from "./ExcelPred.vue?vue&type=template&id=2f5b14ad&scoped=true&"
import script from "./ExcelPred.vue?vue&type=script&lang=js&"
export * from "./ExcelPred.vue?vue&type=script&lang=js&"
import style0 from "./ExcelPred.vue?vue&type=style&index=0&id=2f5b14ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b14ad",
  null
  
)

component.options.__file = "ExcelPred.vue"
export default component.exports